<ng-container *transloco="let t">
  <div class="flex items-center gap-2 print:hidden" [ngClass]="{ 'justify-between': showFilter(), 'justify-end': !showFilter() }">
    <!-- Pesquisa -->
    <div mat-form-field [class.hidden]="!showFilter() || reorderRows()" class="flex items-center border-2 rounded-md solid p-2 w-full">
      <mat-icon svgIcon="mat_outline:search" class="my-0 pt-1 mr-2"></mat-icon>
      <input class="w-full" matInput (keyup)="applyFilter($event)" [placeholder]="t(labelFilter()) | titlecase" #input />
    </div>

    <div class="flex items-center gap-2">
      @if (showReload()) {
        <!-- Atualizar -->
        <button mat-icon-button (click)="loadData()">
          <mat-icon svgIcon="mat_outline:sync" class="icon-size-2"></mat-icon>
        </button>

        <!-- Imprimir -->
        <button mat-icon-button (click)="printPage()">
          <mat-icon svgIcon="heroicons_outline:printer"></mat-icon>
        </button>
      }

      @if (exportData()) {
        <!-- Exportar -->
        <hmax-button-menu
          label="export"
          type="icon"
          icon="mat_outline:file_upload"
          class="print:hidden"
          [actions]="exportOptions"
          (optionClick)="exportTable($event)"
        >
        </hmax-button-menu>
      }
    </div>
  </div>

  <div class="flex flex-col flex-auto mt-0 overflow-x-auto">
    <table
      mat-table
      [dataSource]="dataSource"
      matSort
      multiTemplateDataRows
      class="w-full"
      [ngClass]="{ 'bg-transparent': isSubTable() }"
      (matSortChange)="announceSortChange($event)"
      cdkDropList
      [cdkDropListDisabled]="!reorderRows()"
      (cdkDropListDropped)="onRowDropped($event)"
    >
      @if (expandField() && !hasInlineExpandControl) {
        <ng-container matColumnDef="expandControl">
          <mat-header-cell *matHeaderCellDef class="max-w-1"></mat-header-cell>
          <mat-cell *matCellDef="let row" class="max-w-1">
            @if (isExpandable(row)) {
              <button mat-icon-button (click)="toggleExpand(row, $event)">
                <mat-icon
                  [svgIcon]="isExpanded(row) ? 'mat_outline:expand_less' : 'mat_outline:expand_more'"
                  class="icon-size-5 transition-transform duration-200"
                >
                </mat-icon>
              </button>
            }
          </mat-cell>
        </ng-container>
      }

      @for (column of columns(); track column.name) {
        <ng-container [matColumnDef]="column.name">
          <!-- Cabeçalho da coluna -->
          <mat-header-cell
            *matHeaderCellDef
            [hidden]="column.hidden || (column.name === 'id' && column.hidden === undefined)"
            [style.minWidth.px]="column.minWidth"
            [style.maxWidth.px]="column.type === 'SELECTION' ? 40 : column.name === 'actions' ? 56 : column.maxWidth"
            [ngClass]="[column | columnAlignment, column?.hiddenSize ?? '']"
            class="px-1 print:bg-white print:text-black print:border-b print:border-b-gray-200"
          >
            <!-- Nome da coluna com ordenação -->
            @if (
              !column?.hideTitle &&
              column.name !== 'actions' &&
              column.type !== 'SELECTION' &&
              !(column.type === 'CHECKBOX' && column.isSelectAll)
            ) {
              <!-- Nome da coluna com ordenação -->
              @if (enableSort() && !reorderRows()) {
                <mat-sort-header mat-sort-header>
                  <ng-container *ngTemplateOutlet="translatedText; context: { column: column }"></ng-container>
                </mat-sort-header>
              } @else {
                <!-- Nome da coluna sem ordenação -->
                <span class="pr-0">
                  <ng-container *ngTemplateOutlet="translatedText; context: { column: column }"></ng-container>
                </span>
              }
              <!-- Verificar Tradução -->
              <ng-template #translatedText let-column="column">
                @if (column.translate === undefined || column.translate === true) {
                  {{ column?.headerTitleCase === false ? t(column.alias || column.name) : (t(column.alias || column.name) | capitalize) }}
                } @else {
                  {{ column?.headerTitleCase === false ? column.alias || column.name : (column.alias || column.name | capitalize) }}
                }
              </ng-template>
            }

            <!-- Título da coluna de AÇÕES: engrenagem em vez de vazio (F14). O cabeçalho ficava em
                 branco sobre uma coluna que existe em toda tabela, e "Ações" por extenso não cabe nos
                 56px dela. -->
            @if (column.name === 'actions' && !column?.icon && !column?.hideTitle) {
              <!-- `w-full` + `justify-center`: a engrenagem centraliza na coluna, no MESMO eixo do
                   `⋮` de cada linha (que centraliza igual). Deslocar por padding lateral desalinha os
                   dois e joga o hover do botão contra a borda da célula. -->
              <div class="flex w-full justify-center print:hidden">
                <mat-icon class="icon-size-5 text-secondary" [svgIcon]="column.actionsIcon || 'heroicons_outline:cog-6-tooth'"></mat-icon>
              </div>
            }

            @if (column?.icon) {
              <mat-icon
                class="icon-size-4 print:hidden"
                [ngClass]="column.icon.color"
                [svgIcon]="column.icon.name || ''"
                [matTooltip]="column | tooltipText"
                [matTooltipPosition]="column.icon.tooltip?.position || 'above'"
              >
              </mat-icon>
            }

            @if (column.type === 'SELECTION') {
              <mat-checkbox
                (change)="$event ? toggleAllRows() : null"
                [checked]="selection.hasValue() && isAllSelected()"
                [indeterminate]="selection.hasValue() && !isAllSelected()"
                [aria-label]="selection.selected.length | checkboxLabel: selection : null : 0 : dataSource.data.length || 0"
              ></mat-checkbox>
            }

            <!-- Select All de coluna CHECKBOX -->
            @if (column.type === 'CHECKBOX' && column.isSelectAll) {
              <mat-checkbox
                color="primary"
                (click)="$event.stopPropagation()"
                (change)="toggleSelectAll(column)"
                [checked]="isAllCheckboxesChecked(column)"
                [indeterminate]="isSomeCheckboxChecked(column)"
              ></mat-checkbox>
            }

            <!-- Select All de coluna TOGGLE: ao lado do título (que continua visível, ao contrário do
                 CHECKBOX acima — duas colunas TOGGLE sem rótulo seriam indistinguíveis). Liga todas as
                 rows visíveis (respeita o filtro); com todas ligadas, desliga todas.
                 ⚠️ Sem rótulo ao lado: "todos" escrito ali empurrava o título e o cabeçalho saía
                 cortado ("nculado"). Quem diz o que o controle faz é o tooltip, e a coluna pode
                 trocá-lo por um texto do seu domínio (`selectAllTooltip`/`deselectAllTooltip`). -->
            @if (column.type === 'TOGGLE' && column.isSelectAll) {
              <mat-slide-toggle
                class="ml-2 print:hidden"
                (click)="$event.stopPropagation()"
                (change)="toggleSelectAllToggles(column, $event.source)"
                [checked]="isAllCheckboxesChecked(column)"
                [matTooltip]="
                  t(isAllCheckboxesChecked(column) ? column.deselectAllTooltip || 'deselect-all' : column.selectAllTooltip || 'select-all')
                    | capitalize
                "
              ></mat-slide-toggle>
            }
          </mat-header-cell>

          <!-- Dado da célula -->
          <mat-cell
            *matCellDef="let row; let cellIndex = dataIndex"
            [hidden]="column.hidden || (column.name === 'id' && column.hidden === undefined)"
            [style.minWidth.px]="column.minWidth"
            [style.maxWidth.px]="column.type === 'SELECTION' ? 40 : column.name === 'actions' ? 56 : column.maxWidth"
            [class.min-w-0]="column.type === 'TAGS'"
            class="{{
              'px-1 print:bg-white print:text-black print:border-b print:border-b-gray-200' +
                (column.cellClass ? ' ' + column.cellClass : '')
            }}"
            [class.border-b-0]="hideBorderBottom"
            [class.flex-col]="row | checkUnderline: column"
            [class.items-start]="row | checkUnderline: column"
            [ngClass]="[column | columnAlignment, column?.hiddenSize ?? '']"
            (click)="doCellClick(column, cellIndex, row, $event)"
          >
            <!-- Linha principal -->
            <ng-container *ngTemplateOutlet="cellTemplate; context: { row, column, cellIndex }"></ng-container>
          </mat-cell>
        </ng-container>
      }

      <!-- Sub-Tabela -->
      <ng-container matColumnDef="subTable">
        <td mat-cell *matCellDef="let row" class="w-full p-0">
          @if (columns()[0]?.subTable; as subTable) {
            <hmax-table
              [data]="row[subTable.name || '']"
              [showHeader]="false"
              [showPaginator]="false"
              [showFilter]="false"
              [enableSort]="false"
              [smallRow]="true"
              [isSubTable]="true"
              [hideBottomBorder]="subTable.hideBottomBorder ?? true"
              [columns]="subTable.columns ?? []"
            ></hmax-table>
          }
        </td>
      </ng-container>

      <ng-container matColumnDef="expandedDetail">
        <td
          mat-cell
          *matCellDef="let row"
          [attr.colspan]="columnNamesWithExpand.length"
          class="p-0 border-b border-b-[rgba(0,0,0,0.12)] w-full"
        >
          <div class="w-full overflow-hidden" [@detailExpand]="isExpanded(row) ? 'expanded' : 'collapsed'">
            @if (isExpanded(row)) {
              <div class="border-l-[3px] border-black/12 rounded-b pl-5" [ngClass]="expandBgColor()">
                <hmax-table
                  [data]="getExpandData(row)"
                  [columns]="resolvedExpandColumns"
                  [showHeader]="false"
                  [showPaginator]="false"
                  [showFilter]="false"
                  [enableSort]="true"
                  [smallRow]="true"
                  [isSubTable]="true"
                  [hideBottomBorder]="false"
                  [currency]="currency()"
                  [withModified]="withModified()"
                  [exportData]="false"
                  (actionClick)="actionClick.emit($event)"
                  (toggleClick)="toggleClick.emit($event)"
                  (checkboxClick)="checkboxClick.emit($event)"
                  (checkboxSelectAllClick)="checkboxSelectAllClick.emit($event)"
                  (editClick)="editClick.emit($event)"
                  (cellClick)="cellClick.emit($event)"
                  (selectionChange)="selectionChange.emit($event)"
                  (rowDoubleClick)="rowDoubleClick.emit($event)"
                ></hmax-table>
              </div>
            }
          </div>
        </td>
      </ng-container>

      @if (showHeader()) {
        <mat-header-row *matHeaderRowDef="columnNamesWithExpand" [ngStyle]="smallRow() ? { 'min-height': 'auto' } : {}"> </mat-header-row>
      }

      <!--
        `cursor-pointer` também quando há `onClickRow`: a linha navega no clique, e sem o cursor nada
        na tela diz que ela é clicável. Antes só o caso expansível trocava o cursor.
        F15 — `cdkDrag` só liga com `reorderRows`: a linha inteira arrasta, travada no eixo vertical, e no
        toque só depois de segurar um instante, para o dedo ainda conseguir rolar a página.
      -->
      <mat-row
        [ngStyle]="smallRow() ? { 'min-height': 'auto' } : {}"
        *matRowDef="let row; let i = index; columns: columnNamesWithExpand"
        [class.cursor-pointer]="(isExpandable(row) || !!onClickRow()) && !reorderRows()"
        [class.cursor-grab]="reorderRows()"
        cdkDrag
        [cdkDragDisabled]="!reorderRows()"
        cdkDragLockAxis="y"
        cdkDragPreviewContainer="parent"
        [cdkDragStartDelay]="{ touch: 200, mouse: 0 }"
        (click)="doRowClick(i, row)"
        (dblclick)="doubleClick(row, $event)"
      >
      </mat-row>

      <!-- Expand detail row -->
      @if (expandField()) {
        <mat-row
          *matRowDef="let row; columns: ['expandedDetail']"
          class="overflow-hidden border-b-0!"
          [ngStyle]="{ 'min-height': '0', height: isExpanded(row) ? 'auto' : '0' }"
        ></mat-row>
      }

      <mat-row [ngStyle]="{ 'min-height': 'auto' }" *matRowDef="let row; columns: ['subTable']; when: hasSubTable"></mat-row>

      <!-- Rodapé -->
      <!-- FOOTER: só aparece se houver total -->
      @if (total()) {
        <ng-container matColumnDef="footerLabel">
          <mat-footer-cell *matFooterCellDef class="font-bold text-lg px-1">
            {{ t('total') | titlecase }}
          </mat-footer-cell>
        </ng-container>

        <!-- Coluna valor -->
        <ng-container matColumnDef="footerValue">
          <mat-footer-cell *matFooterCellDef class="px-1">
            <div class="font-bold text-right text-lg w-full">{{ total() || 0 | number: '1.2-2' }}</div>
          </mat-footer-cell>
        </ng-container>

        <!-- Linha do rodapé -->
        <mat-footer-row class="border-t" *matFooterRowDef="['footerLabel', 'footerValue']"></mat-footer-row>
      }

      <!-- Texto exibido caso não haja registro após um filtro -->
      <tbody>
        <tr *matNoDataRow>
          @if (dataSource.filter) {
            <td class="text-red-500">{{ t('no-match-filter') }} "{{ input.value }}"</td>
          }
        </tr>
      </tbody>
    </table>

    @if (showPaginator()) {
      <!-- F15 — escondido, e não removido, enquanto as linhas arrastam: o `@ViewChild` continua valendo e a
           paginação volta quando o modo desliga. -->
      <mat-paginator
        [class.hidden]="reorderRows()"
        class="pl-0 pt-0"
        [pageSize]="pageSize()"
        [pageSizeOptions]="[5, 6, 7, 8, 9, 10, 20, 30, 40, 50]"
        [pageIndex]="currentPage"
        [length]="totalItems"
        showFirstLastButtons
      ></mat-paginator>
    }
  </div>

  <!-- Template da célula -->
  <ng-template #cellTemplate let-row="row" let-column="column" let-cellIndex="cellIndex">
    <div
      [ngClass]="row[column?.class ?? '']"
      [ngStyle]="row[column?.style ?? '']"
      [class.relative]="column?.expandOnClick"
      [class.flex]="!!column?.inlineBadge"
      [class.items-center]="!!column?.inlineBadge"
    >
      @if (column?.expandOnClick && isExpandable(row)) {
        <mat-icon
          [svgIcon]="isExpanded(row) ? 'mat_outline:expand_less' : 'mat_outline:expand_more'"
          class="icon-size-5 text-current absolute left-2 top-1/2 -translate-y-1/2 cursor-pointer transition-transform duration-200"
          (click)="toggleExpand(row, $event)"
        ></mat-icon>
      }
      @switch (column?.type) {
        <!-- CHIPS em UMA linha (F14): o corte é por largura medida, no `hmax-table-tags` — a lógica
             não cabe aqui porque depende de `ResizeObserver` e das medidas de cada chip. -->
        @case ('TAGS') {
          <hmax-table-tags [tags]="$any(asArray(row[column.name]))" [translate]="column.translate === true" />
        }

        <!-- Posição com as setas ao lado, sob o mesmo título (F15/D200). O valor da coluna sai pelo caminho
             da NUMBER (0 só quando gravado, vazio em branco); as setas emitem `moveUp`/`moveDown` pelo
             mesmo `actionClick` das ações, então a tela trata as duas coisas num lugar só. A seta que não
             tem para onde ir some, mas guarda o lugar, e o número tem largura mínima: a coluna não dança
             entre a primeira e a última linha. -->
        @case ('REORDER') {
          <div class="flex items-center gap-1">
            @if (reorderRows()) {
              <!-- O ícone padrão de arrastar, ao lado do número, só enquanto as linhas arrastam (F15, Organizar). A
                   linha inteira continua arrastável: o ícone é o sinal de que ela arrasta. -->
              <mat-icon
                class="icon-size-5 text-hint cursor-grab print:hidden"
                svgIcon="mat_outline:drag_indicator"
                data-testid="reorder-drag-icon"
              ></mat-icon>
            }
            <span class="min-w-6 text-right tabular-nums">{{ row | columnFormattedValue: column : currency() }}</span>
            <div class="flex items-center print:hidden">
              <hmax-button-icon-small
                icon="heroicons_outline:arrow-up"
                [tooltipText]="t('move-up') | capitalize"
                [class.invisible]="!!row[column.reorderFirstField ?? '']"
                (click)="$event.stopPropagation(); doActionClick('moveUp', cellIndex, row)"
              ></hmax-button-icon-small>
              <hmax-button-icon-small
                icon="heroicons_outline:arrow-down"
                [tooltipText]="t('move-down') | capitalize"
                [class.invisible]="!!row[column.reorderLastField ?? '']"
                (click)="$event.stopPropagation(); doActionClick('moveDown', cellIndex, row)"
              ></hmax-button-icon-small>
            </div>
          </div>
        }

        <!-- Ícone por LINHA (F14): o `column.icon` do cabeçalho é outro recurso. -->
        @case ('ICON') {
          @if (row[column.name]) {
            <mat-icon class="icon-size-5" [svgIcon]="(column.iconPrefix || 'mat_outline') + ':' + row[column.name]"></mat-icon>
          }
        }

        <!-- Link -->
        @case ('LINK') {
          @if (row[column?.linkField || '']; as linkValue) {
            @if (!column?.isInternalLink) {
              <a
                [href]="row[linkValue]"
                target="_blank"
                rel="noopener noreferrer"
                class="text-blue-600 hover:text-blue-400 underline"
                [matTooltip]="column | tooltipText"
              >
                @if (column.icon?.name) {
                  <mat-icon [svgIcon]="column.icon.name" class="icon-size-5" [ngClass]="column.icon.color || ''"></mat-icon>
                } @else {
                  {{ (column?.linkAliasTranslate ? t(row[column?.linkAlias ?? '']) : row[column?.linkAlias ?? '']) | titlecase }}
                }
              </a>
            }
            @if (column.isInternalLink) {
              <a
                [routerLink]="[row[linkValue]]"
                class="text-blue-600 hover:text-blue-400 underline cursor-pointer"
                [matTooltip]="column | tooltipText"
              >
                @if (column.icon?.name) {
                  <mat-icon [svgIcon]="column.icon.name" class="icon-size-5" [ngClass]="column.icon.color || ''"></mat-icon>
                } @else {
                  {{ (column?.linkAliasTranslate ? t(row[column?.linkAlias ?? '']) : row[column?.linkAlias ?? '']) | titlecase }}
                }
              </a>
            }
          }
        }

        <!-- Selection -->
        @case ('SELECTION') {
          <mat-checkbox
            (click)="$event.stopPropagation()"
            (change)="$event ? toggleSelection(row) : null"
            [checked]="selection.isSelected(row)"
            [disabled]="!isRowSelectable(row)"
            [aria-label]="selection.selected.length | checkboxLabel: selection : row : cellIndex : dataSource.data.length || 0"
          >
          </mat-checkbox>
        }

        <!-- Toggle. `isToggleChecked` em vez do `columnValue`: aquele é pipe PURO e não reavalia
             quando o "marcar todos" muta a row no lugar, o que deixava a linha desligada na tela com
             o dado ligado. -->
        @case ('TOGGLE') {
          <mat-slide-toggle [checked]="isToggleChecked(row, column)" (change)="doToggleClick(row, column)"> </mat-slide-toggle>
        }

        <!-- CheckBox -->
        @case ('CHECKBOX') {
          <mat-checkbox color="primary" [checked]="row[column.name]" (change)="onCheckboxChange(row, column)"> </mat-checkbox>
        }

        <!-- Imagem -->
        @case ('IMAGE') {
          @if (row[column.name]; as imageSrc) {
            <img
              [src]="imageSrc"
              [alt]="
                (column.imageConfig?.altTranslate
                  ? t(row[column.imageConfig?.alt] || row[column.alias] || row[column.name])
                  : row[column.imageConfig?.alt] || row[column.alias] || row[column.name]
                ) | capitalize
              "
              [width]="column.imageConfig?.width || 40"
              [height]="column.imageConfig?.height || 40"
              [ngClass]="column.imageConfig?.class || 'object-cover'"
              [style.object-fit]="column.imageConfig?.objectFit || 'cover'"
              [style.width.px]="column.imageConfig?.width || 40"
              [style.height.px]="column.imageConfig?.height || 40"
              [matTooltip]="
                (column.imageConfig?.tooltipTranslate ? t(row[column.imageConfig?.tooltip]) : row[column.imageConfig?.tooltip]) | capitalize
              "
              [matTooltipPosition]="column.imageConfig?.tooltipPosition || 'above'"
              onerror="
                this.style.display = 'none';
                this.insertAdjacentHTML('afterend', this.alt);
              "
            />
          }
        }

        <!-- Badge -->
        @case ('BADGE') {
          @if (row[column.name]; as badge) {
            <mat-chip selected [style.background-color]="badge?.color">
              <!-- O label chega traduzido do componente, e as chaves do painel são minúsculas. -->
              <span [style.color]="badge?.textColor">{{ badge?.label | capitalize }}</span>
            </mat-chip>
          }
        }

        <!-- Input -->
        @case ('INPUT') {
          <div class="input-container relative group focus-within:opacity-100">
            @if (isNumericInputColumn(column)) {
              <!-- Célula numérica (preço, etc.): exibe vírgula, "0,00" quando vazia, normaliza casas no blur e seleciona tudo no foco -->
              <input
                #inputField
                matInput
                size="small"
                [attr.data-row]="cellIndex"
                [attr.data-column]="column.name"
                inputmode="decimal"
                [readonly]="false"
                [value]="numericInputDisplayValue(row, column)"
                class="input-field"
                (keydown)="onNumericInputKeydown($event, column)"
                (input)="onInputChange(row, column, $event)"
                (focus)="onNumericInputFocus($event, column)"
                (blur)="onNumericInputBlur(row, column, $event)"
              />
            } @else if (typesColumnFormatted.includes(column?.type || '')) {
              <input
                #inputField
                matInput
                size="small"
                [attr.data-row]="cellIndex"
                [attr.data-column]="column.name"
                [attr.inputmode]="isNumericInputColumn(column) ? 'decimal' : null"
                [readonly]="false"
                [value]="(row | columnFormattedValue: column : currency() : true) || ''"
                class="input-field"
                (keydown)="onNumericInputKeydown($event, column)"
                (input)="onInputChange(row, column, $event)"
              />
            } @else {
              <input
                #inputField
                matInput
                size="small"
                [attr.data-row]="cellIndex"
                [attr.data-column]="column.name"
                [attr.inputmode]="isNumericInputColumn(column) ? 'decimal' : null"
                [readonly]="false"
                [value]="
                  ((column.translate ? t(row | columnValue: column | lowercase) : (row | columnValue: column))
                    | formatColumnText: column) || ''
                "
                class="input-field"
                (keydown)="onNumericInputKeydown($event, column)"
                (input)="onInputChange(row, column, $event)"
              />
            }
            <mat-icon
              svgIcon="heroicons_outline:pencil"
              class="icon-size-4 ml-1 group-focus-within:opacity-0"
              (click)="focusInputAt(cellIndex, column?.name)"
            >
            </mat-icon>
          </div>
        }

        <!-- Padrão -->
        @default {
          @if (typesColumnFormatted.includes(column?.type || '')) {
            {{ row | columnFormattedValue: column : currency() }}
          } @else {
            {{ (column.translate ? t(row | columnValue: column | lowercase) : (row | columnValue: column)) | formatColumnText: column }}
          }
          @if (column.chip && row[column.chip]) {
            <span class="relative inline-flex items-start align-top">
              <span
                [matTooltip]="(t('accommodation') | capitalize) + ': ' + row[column.chip]"
                class="absolute -top-2.5 left-0 flex items-center justify-center min-w-3.5 h-3.5 rounded-full bg-white text-black text-xs font-bold"
              >
                {{ row[column.chip] }}
              </span>
            </span>
          }
        }
      }

      <!-- Badge inline na mesma linha do valor principal (forma `InlineBadge`), centralizado com o texto pelo
           `flex items-center` do container acima. Desenhado pelo `hmax-action-pill`, o MESMO componente do mapa de
           contas: o template dele é encapsulado, então a regra `.icon-size-4` deste SCSS não desloca os ícones. -->
      @if (column?.inlineBadge && row[column.inlineBadge.name]; as badge) {
        <hmax-action-pill
          class="ml-2"
          data-testid="table-inline-badge"
          [label]="badge.label"
          [icon]="badge.icon"
          [tooltip]="badge.tooltip"
          [background]="badge.color"
          [color]="badge.textColor"
          [actionIcon]="badge.action?.icon"
          [actionLabel]="badge.action?.label"
          [actionColor]="badge.action?.color || badge.textColor"
          [actionDisabled]="!!badge.action?.disabled"
          actionTestId="table-inline-badge-action"
          (actionPressed)="doActionClick(badge.action.method, cellIndex, row)"
        />
      }
    </div>

    <!-- Sub-linha -->
    @if (column?.subline) {
      @if (row | checkUnderline: column) {
        <!-- Se for string, mantém o comportamento atual -->
        @if (column.subline | isType: 'string') {
          <div class="w-full text-sm text-secondary overflow-hidden whitespace-nowrap text-ellipsis">{{ row[column.subline || ''] }}</div>
        }

        <!-- Sub-linha como coluna -->
        @if ((column.subline | isType: 'object') && !(column.subline | isType: 'array')) {
          <ng-container *ngTemplateOutlet="cellTemplate; context: { row: row, column: column.subline, cellIndex }"></ng-container>
        }

        <!-- Várias sublinhas -->
        @if (column.subline | isType: 'array') {
          @for (sub of column.subline; track $index) {
            <div class="text-xs text-gray-500">
              <ng-container *ngTemplateOutlet="cellTemplate; context: { row: row, column: sub, cellIndex }"></ng-container>
            </div>
          }
        }
      }
    }

    <!-- Actions -->
    @if (column?.actions?.length) {
      <!-- Centralizado na coluna: o `mat-icon-button` tem alvo de 40px e a célula só 48px úteis, então
           qualquer padding lateral empurra o hover para fora do `overflow-hidden` da célula. -->
      <div class="flex w-full justify-center print:hidden">
        <button mat-icon-button [matMenuTriggerFor]="actionsMenu">
          <mat-icon class="icon-size-5" svgIcon="mat_outline:more_vert"> </mat-icon>
        </button>

        <mat-menu #actionsMenu="matMenu">
          @for (action of column.actions; track $index; let i = $index) {
            @if ((!!action.divider || (action.label === 'remove' && (column.actions?.length ?? 0) > 1)) && !row[action?.hide]) {
              <mat-divider class="my-2"> </mat-divider>
            }
            @if (!row[action?.hide] && !action.divider) {
              <button mat-menu-item (click)="doActionClick(action.method, i, row)">
                <mat-icon class="icon-size-5" [ngClass]="action?.class" [svgIcon]="action?.icon || ''"></mat-icon>
                <span [ngClass]="action?.class">{{ (action?.translate !== false ? t(action.label) : action.label) | capitalize }}</span>
              </button>
            }
          }
        </mat-menu>
      </div>
    }

    <!-- Sub-Tabela -->
    @if (column.subTable; as subTable) {
      @if (!subTable.hideInCell) {
        <ng-container *ngTemplateOutlet="subTableTemplate; context: { row: row, subTable: subTable }"></ng-container>
      }
    }
  </ng-template>

  <!-- Template Sub-Tabela -->
  <ng-template #subTableTemplate let-row="row" let-subTable="subTable">
    <hmax-table
      [data]="row[subTable.name || '']"
      [showHeader]="false"
      [showPaginator]="false"
      [showFilter]="false"
      [enableSort]="false"
      [smallRow]="true"
      [isSubTable]="true"
      [hideBottomBorder]="subTable.hideBottomBorder ?? true"
      [columns]="subTable.columns ?? []"
    >
    </hmax-table>
  </ng-template>
</ng-container>
